export default class EnviaTelefone {
  constructor () {
    this.telefone = null
    this.identificacaoFiscal = null
  }
}
